module.exports = __webpack_public_path__ + "media/images/admin/logo-f9dcc79f79451a3c3fcbb47c4db9a6af.png";